import * as React from 'react';
import { Tab, Tabs } from '@mui/material';
import { useTranslation } from "react-i18next";
import { ScheduleEntry } from '../../domain/ScheduleEntry';
import ScheduleWeekendTab from './ScheduleWeekendTab';
import ScheduleWorkdayTab from './ScheduleWorkdayTab';
import { ScheduleWeek } from '../../domain/ScheduleWeek';
import ScheduleFieldServiceTab from './ScheduleFieldServiceTab';
import moment from 'moment';
import { ScheduleView } from './ScheduleContent';

interface Props {
    week?: ScheduleWeek;
    entries: ScheduleEntry[];
    editable?: boolean;
    view: ScheduleView;
    onEntryUpdate?: (entry: ScheduleEntry) => void;
    onEntryEdit?: (entry: ScheduleEntry) => void;
    onPublisherScheduleHistory?: (entry: ScheduleEntry) => void;
    onEntryAssignmentHistory?: (entry: ScheduleEntry) => void;
    onEntrySendNotification?: (entry: ScheduleEntry) => void;
    onEntryDownload?: (entry: ScheduleEntry) => void;
    onEntryAutoArrange?: (entry: ScheduleEntry) => void;
}

const SchedulePageTabs = (props: Props) => {
    const { t } = useTranslation();
    const [tab, setTab] = React.useState(0);

    React.useEffect(() => {
        if (props.week) {
            const dayNum = moment().isoWeekday();
            if (dayNum === 6 || dayNum === 7) {
                setTab(1);
            }
        }
    }, [props.week]);

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
    };

    return (
        <>
            <Tabs value={tab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
                <Tab label={t("workdays")} />
                <Tab label={t("weekends")} />
                <Tab label={t("field_service_meetings")} />
            </Tabs>
            <div role="tabpanel" hidden={tab !== 0}>
                <ScheduleWorkdayTab
                    week={props.week!}
                    entries={props.entries.filter(entry => entry.type === "workday")}
                    editable={props.editable}
                    view={props.view}
                    onEntryUpdate={props.onEntryUpdate}
                    onEntryEdit={props.onEntryEdit}
                    onPublisherScheduleHistory={props.onPublisherScheduleHistory}
                    onEntryAssignmentHistory={props.onEntryAssignmentHistory}
                    onEntrySendNotification={props.onEntrySendNotification}
                    onEntryDownload={props.onEntryDownload}
                    onEntryAutoArrange={props.onEntryAutoArrange}
                />
            </div>
            <div role="tabpanel" hidden={tab !== 1}>
                <ScheduleWeekendTab
                    week={props.week!}
                    entries={props.entries.filter(entry => entry.type === "weekend")}
                    editable={props.editable}
                    view={props.view}
                    onEntryUpdate={props.onEntryUpdate}
                    onEntryEdit={props.onEntryEdit}
                    onPublisherScheduleHistory={props.onPublisherScheduleHistory}
                    onEntryAssignmentHistory={props.onEntryAssignmentHistory}
                    onEntrySendNotification={props.onEntrySendNotification}
                    onEntryAutoArrange={props.onEntryAutoArrange}
                />
            </div>
            <div role="tabpanel" hidden={tab !== 2}>
                <ScheduleFieldServiceTab
                    week={props.week!}
                    entries={props.entries.filter(entry => entry.type === "field-service")}
                    editable={props.editable}
                    view={props.view}
                    onEntryUpdate={props.onEntryUpdate}
                    onEntryEdit={props.onEntryEdit}
                    onPublisherScheduleHistory={props.onPublisherScheduleHistory}
                    onEntryAssignmentHistory={props.onEntryAssignmentHistory}
                    onEntrySendNotification={props.onEntrySendNotification}
                    onEntryAutoArrange={props.onEntryAutoArrange}
                />
            </div>
        </>
    );
};

export default SchedulePageTabs;
